import React, { useState, useEffect } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { LoadingPanel } from "../Loading";

interface Props {
  tableData: any[];
  tableConfig: any[];
  loading: boolean;
  // detailComponent: (props: any) => JSX.Element;
  detailComponent: (props: any) => JSX.Element;
  requestNewPage: (skip: number, take: number, sort?: any) => void;
  take: number;
  skip: number;
  total: number;
  sort: any;
  setSort: (sort: any) => void;
}

export const columnHeader = (props: any, tooltipText?: string) => {
  return (
    <a className="k-link" data-cy={props.title} onClick={props.onClick}>
      <span title={tooltipText} style={{ whiteSpace: "normal" }}>
        {props.title}
      </span>
      {props.children}
    </a>
  );
};

export default (props: Props) => {
  const [data, setData] = useState(props.tableData);

  useEffect(() => {
    setData(props.tableData);
  }, [props.tableData]);

  const handleChangePage = (event: any) => {
    const { take, skip } = event.page;
    props.requestNewPage(skip, take, Object.values(props.sort[0]).filter(x => x !== null).length > 0 ? props.sort : null);
  };

  const handleChangeSort = (event: any) => {
    const sort = event.sort;
    props.setSort(sort);
    props.requestNewPage(props.skip, props.take, sort);
  };

  const expandChange = (event: any) => {
    event.dataItem.expanded = event.value;
    const updatedData = JSON.parse(JSON.stringify(data));
    setData(updatedData);
  };

  return (
    <div>
      {props.loading && <LoadingPanel />}
      <Tooltip openDelay={100} position="right" anchorElement="element">
        <Grid
          style={{ fontSize: "100%" }}
          data={data}
          detail={(detailProps: any) => props.detailComponent(detailProps)}
          expandField="expanded"
          onExpandChange={expandChange}
          resizable
          scrollable={'none'}
          pageable={true}
          sortable={true}
          sort={props.sort}
          take={props.take}
          skip={props.skip}
          total={props.total}
          onPageChange={handleChangePage}
          onSortChange={handleChangeSort}
        >
          {props.tableConfig.map((column: any, key: number) => {
            if (column.custom) {
              return (
                <Column
                  key={key}
                  field={column.rowValue}
                  title={column.headTitle}
                  cell={(detailProps: any) => column.custom(detailProps)}
                  sortable={column.sortable}
                  headerCell={(props: any) =>
                    columnHeader(props, column.tooltipText)
                  }
                />
              );
            }
            return (
              <Column
                key={key}
                field={column.rowValue}
                title={column.headTitle}
                sortable={column.sortable}
                headerCell={(props: any) =>
                  columnHeader(props, column.tooltipText)
                }
              />
            );
          })}
        </Grid>
      </Tooltip>
    </div>

  );
};
